export function shouldBeFixed(fixedBound: number) {
  return (node: HTMLElement) => window.innerHeight - node.getBoundingClientRect().top < fixedBound;
}
